<div class="geo-location">
  <input
    ngx-google-places-autocomplete
    [options]="options"
    class="form-control m-input"
    (onAddressChange)="autoCompleteCallback($event)"
    />
    <!-- #placesRef="ngx-places" -->
</div>
